window.dtEmployeeList = function () {
  const dtEmployeeList = new DataTable('#employee-list-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#employee-list-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#employee-list-datatable', 6); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'asc']],
    columns: [
      { data: "index" },
      { data: "status" },
      { data: "full_name" },
      { data: "position" },
      { data: "email" },
      { data: "phone" }
    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row) {
      $('td', row).addClass('py-1');
    }
  });

  dtFinalTouch();
  return dtEmployeeList;
}

window.dtEmployee = window.dtEmployeeList;
